module.exports = __webpack_public_path__ + "img/avartar.bfb2c28e.png";